import { render, staticRenderFns } from "./Linklist.vue?vue&type=template&id=4ab966c3&scoped=true"
import script from "./Linklist.vue?vue&type=script&lang=js"
export * from "./Linklist.vue?vue&type=script&lang=js"
import style0 from "./Linklist.vue?vue&type=style&index=0&id=4ab966c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab966c3",
  null
  
)

export default component.exports